var map = {
	"./cn.svg": "8f59",
	"./de.svg": "eca6",
	"./fr.svg": "8f00",
	"./hk.svg": "7689",
	"./otc.png": "0356",
	"./pink.png": "8432",
	"./pink.svg": "b388",
	"./ru.svg": "a0fd",
	"./uk.svg": "a135",
	"./usa.svg": "d7ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "757f";